import type { ModelData } from '@/shared/stores/model-utils'

export const model15InitialModel: ModelData = {
  name: 'Template 15 - Double Door With Solid Frames',
  modelId: 'model15',
  type: 'DOOR',
  description:
    '15-variant single and double door with solid frames and glass panels',
  width: 3600,
  height: 2200,
  photoId: null,
  attachments: [],
  parameters: [
    // Main Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 3600,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 2200,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 2200,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 3540, y: 0, z: 0 },
    },
    // Fixed section vertical frames
    {
      positionId: 'vertical_frame_profile_1',
      type: 'PROFILE',
      width: 60,
      height: 2140,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 240, y: 60, z: 0 },
    },
    {
      positionId: 'vertical_frame_profile_2',
      type: 'PROFILE',
      width: 60,
      height: 2140,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1200, y: 60, z: 0 },
    },
    {
      positionId: 'vertical_frame_profile_3',
      type: 'PROFILE',
      width: 60,
      height: 2140,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1620, y: 60, z: 0 },
    },
    {
      positionId: 'vertical_frame_profile_4',
      type: 'PROFILE',
      width: 60,
      height: 2140,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 3300, y: 60, z: 0 },
    },

    // Bottom Frame profiles for all sections
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 300,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2140, z: 0 },
    },
    {
      positionId: 'bottom_middle_frame_profile',
      type: 'PROFILE',
      width: 480,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1200, y: 2140, z: 0 },
    },
    {
      positionId: 'double_door_bottom_frame_profile_1',
      type: 'PROFILE',
      width: 780,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1680, y: 2140, z: 0 },
    },
    {
      positionId: 'double_door_bottom_frame_profile_2',
      type: 'PROFILE',
      width: 780,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2520, y: 2140, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 300,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 3300, y: 2140, z: 0 },
    },

    // Single door vertical frame profiles
    {
      positionId: 'single_door_left_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 1880,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 300, y: 320, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'single_door_horizontal_handle',
            type: 'HORIZONTAL_HANDLE',
            width: 120,
            height: 200,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 5, y: 790, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'single_door_right_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 1880,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1140, y: 320, z: 0 },
      hardware: {
        hinges: [
          {
            positionId: 'single_door_right_top_hinge_1',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 60, z: 10 },
          },
          {
            positionId: 'single_door_right_top_hinge_2',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 310, z: 10 },
          },
          {
            positionId: 'single_door_right_top_hinge_3',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 560, z: 10 },
          },
          {
            positionId: 'single_door_right_bottom_hinge_1',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 1350, z: 10 },
          },
          {
            positionId: 'single_door_right_bottom_hinge_2',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 1550, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'single_door_top_frame_profile',
      type: 'PROFILE',
      width: 900,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 300, y: 320, z: 0 },
    },
    {
      positionId: 'single_door_bottom_frame_profile',
      type: 'PROFILE',
      width: 900,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 300, y: 2140, z: 0 },
    },

    // Double door frame profiles
    {
      positionId: 'double_door_1_left_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 1880,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1680, y: 320, z: 0 },
      hardware: {
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: -25, y: 60, z: 10 },
          },
          {
            positionId: 'door_1_left_top_hinge_2',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: -25, y: 310, z: 10 },
          },
          {
            positionId: 'door_1_left_top_hinge_3',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: -25, y: 560, z: 10 },
          },
          {
            positionId: 'door_1_left_bottom_hinge_1',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: -25, y: 1350, z: 10 },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: -25, y: 1550, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'double_door_1_right_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 1880,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2400, y: 320, z: 0 },
    },
    {
      positionId: 'double_door_middle_vertical_frame_profile_center',
      type: 'PROFILE',
      width: 60,
      height: 1880,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2460, y: 320, z: 0 },
    },
    {
      positionId: 'double_door_2_left_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 1880,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2520, y: 320, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'double_door_2_left_handle',
            type: 'HORIZONTAL_HANDLE',
            width: 120,
            height: 200,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 5, y: 790, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'double_door_2_right_frame_profile',
      type: 'PROFILE',
      width: 60,
      height: 1880,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 3240, y: 320, z: 0 },
      hardware: {
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 60, z: 10 },
          },
          {
            positionId: 'door_2_right_top_hinge_2',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 310, z: 10 },
          },
          {
            positionId: 'door_2_right_top_hinge_3',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 560, z: 10 },
          },
          {
            positionId: 'door_2_right_bottom_hinge_1',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 1350, z: 10 },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: 25,
            height: 100,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 60, y: 1550, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'double_door_middle_horizontal_frame_profile',
      type: 'PROFILE',
      width: 1620,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1680, y: 260, z: 0 },
    },
    {
      positionId: 'double_door_1_top_frame_profile',
      type: 'PROFILE',
      width: 780,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1680, y: 320, z: 0 },
    },
    {
      positionId: 'double_door_2_top_frame_profile',
      type: 'PROFILE',
      width: 780,
      height: 60,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2520, y: 320, z: 0 },
    },

    // Glass Panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 180,
      height: 2080,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 60, y: 60, z: 0 },
    },
    {
      positionId: 'middle_glass_panel',
      type: 'GLASS',
      width: 360,
      height: 2080,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1260, y: 60, z: 0 },
    },
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 180,
      height: 2080,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 3360, y: 60, z: 0 },
    },
    {
      positionId: 'single_door_top_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 200,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 300, y: 60, z: 0 },
    },
    {
      positionId: 'double_door_top_glass_panel',
      type: 'GLASS',
      width: 1620,
      height: 200,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1680, y: 60, z: 0 },
    },
    {
      positionId: 'single_door_glass_panel',
      type: 'GLASS',
      width: 780,
      height: 1760,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 360, y: 380, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'single_door_horizontal_handle',
            type: 'HORIZONTAL_HANDLE',
            width: 120,
            height: 200,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: -60, y: 790, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'double_door_glass_panel_1',
      type: 'GLASS',
      width: 660,
      height: 1760,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1740, y: 380, z: 0 },
      hardware: {
        handles: [],
      },
    },
    {
      positionId: 'double_door_glass_panel_2',
      type: 'GLASS',
      width: 660,
      height: 1760,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 2570, y: 380, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'complex_multi_section',
    sections: [
      { type: 'fixed', width: 300 },
      { type: 'single_door', width: 900 },
      { type: 'fixed', width: 480 },
      { type: 'double_door', width: 1620, individual: [810, 810] },
      { type: 'fixed', width: 300 },
    ],
    individualDoorWidth: [900, 810, 810],
    totalDoorWidth: 3600,
    totalDoorHeight: 2200,
    totalHandles: 2,
    openingDirection: 'right_opening',
    hingePosition: 'right_side',
    doubleLeftDoorWidth: 810,
    doubleRightDoorWidth: 810,
    singleDoorWidth: 900,
    centerSeparatorWidth: 60,
  },
}
